export const FORMAT_PATTERNS = {
  MM_DD_YYYY: 'MM/DD/YYYY', // 06/15/2024
  DD_MM_YYYY: 'DD/MM/YYYY', // 15/06/2024
  YYYY_MM_DD: 'YYYY/MM/DD', // 2024/06/15
  MM_YYYY: 'MM/YYYY', // 06/2024
  MMM_DD_YYYY_COMMA: 'MMM DD, YYYY', // Jun 15, 2024
  MMM_DD_YYYY: 'MMM DD YYYY', // Jun 15 2024
  DD_MMM_YYYY: 'DD-MMM-YYYY', // 15-Jun-2024
  DD_MMM_YYYY_COMMA: 'DD MMM, YYYY', // 15 Jun, 2024
  MMM_YYYY: 'MMM YYYY', // Jun 2024
  MMMM_DD_YYYY: 'MMMM DD YYYY', // June 15 2024
  MMMM_DD_YYYY_COMMA: 'MMMM DD, YYYY', // June 15, 2024
  DD_MMMM_YYYY: 'DD MMMM YYYY', // 15 June 2024
  DD_MMMM_YYYY_COMMA: 'DD MMMM, YYYY', // 15 June, 2024

  MMMM_YYYY: 'MMMM YYYY', // June 2024
};
